import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Zap } from 'lucide-react';
import { scrollToSection } from '@/lib/scroll';

const FlashingBanner = () => {
  const [visible, setVisible] = useState(true);
  const prefersReduced =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed top-[64px] md:top-[80px] left-0 right-0 z-40
                     bg-gradient-to-r from-teal-700 via-teal-600 to-amber-600
                     shadow-lg overflow-hidden"
          aria-live="polite"
          role="banner"
        >
          {/* Shimmer sweep */}
          {!prefersReduced && (
            <div
              className="banner-shimmer absolute inset-0 pointer-events-none"
              style={{
                background: 'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.12) 50%, transparent 80%)',
                width: '50%',
              }}
              aria-hidden
            />
          )}
          <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-3 relative z-10">
            <div className="flex items-center gap-2 min-w-0">
              <span className="flex-shrink-0 w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <Zap className="w-3.5 h-3.5 text-white" />
              </span>
              <p className="text-white text-xs sm:text-sm font-semibold truncate">
                <span className={`mr-1 ${prefersReduced ? '' : 'inline-block animate-pulse'}`}>🔥</span>
                <span className="hidden sm:inline">Limited-time offer — </span>
                <strong>Discount on AI &amp; Cloud courses.</strong>
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <button
                onClick={() => scrollToSection('register')}
                className="text-xs sm:text-sm font-bold text-teal-700
                           bg-white hover:bg-teal-50
                           px-3.5 py-1 rounded-full
                           shadow-sm hover:shadow-md
                           transition-all duration-200 whitespace-nowrap"
              >
                Enroll Now →
              </button>
              <button
                onClick={() => setVisible(false)}
                aria-label="Dismiss banner"
                className="w-6 h-6 flex items-center justify-center rounded-full
                           text-white/70 hover:text-white
                           hover:bg-white/15 transition-colors duration-200"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FlashingBanner;
